import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'

import GlobalReducer from './GlobalReducer'
import HomeReducer from './HomeReducer'

export default combineReducers({
	Router 		: routerReducer,
	Global 		: GlobalReducer,
	Home 		: HomeReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/index.js